var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt",
    transform: "translate(8404.5 -1541.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(-8478.258 1549.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2787",
    "data-name": "Path 2787",
    d: "M184,270.111A126.111,126.111,0,1,0,310.111,144,12.611,12.611,0,0,0,297.5,156.611V257.5H196.611A12.611,12.611,0,0,0,184,270.111Zm126.111,12.611a12.611,12.611,0,0,0,12.611-12.611V170.01A100.889,100.889,0,1,1,210.01,282.722Z",
    transform: "translate(18.444 18.444)",
    fill: "rgba(230,85,85,0.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2788",
    "data-name": "Path 2788",
    d: "M164.611,250.722h113.5a12.611,12.611,0,0,0,12.611-12.611v-113.5A12.611,12.611,0,0,0,278.111,112,126.254,126.254,0,0,0,152,238.111,12.611,12.611,0,0,0,164.611,250.722ZM265.5,138.01V225.5H178.01A101.106,101.106,0,0,1,265.5,138.01Z",
    transform: "translate(0 0)",
    fill: "#e65555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.11e363a0af39b73988c6d9f84f41d75e.svg";
export { ForwardRef as ReactComponent };